import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const VideoPreview = require('../../../../../assets/img/timeline/modal/2014-Poems.jpg');

const PoemsResultsContent = () => {
    return (
        <>
            <TimelineVideo videoId="wjRC9Z3yYug" imagePreview={VideoPreview} />
            <h4>
                POEMS clinical trial results
            </h4>
            <p>
                The result of the POEMS clinical trial found that women who received goserelin were less likely to be in menopause two years after their cancer treatment (8% compared with 22%) and were twice as likely to have a pregnancy after their cancer treatment. Breast Cancer Trials (BCT) recruited 58 women to this clinical trial and our involvement led to the PBS listing of goserelin in Australia. Professor Kelly-Anne Phillips is the BCT Study Chair of POEMS.
            </p>
        </>
    );
}

export default PoemsResultsContent;